const MuiAccordionDetails = {
  styleOverrides: {
    root: {
      padding: '0'
    }
  }
};
export default MuiAccordionDetails;